import { CompanyDto } from './companyDto'
import { VehicleDto } from './vehicle'

export class VehicleDamageDetailsDto {
  vehicleDamageGuid?: string = undefined
  damageDescription?: string = undefined
  damageStatus?: string = undefined
  vehicleGuid?: string = undefined
  vehicleId?: string = undefined
  vehicle?: VehicleDto = undefined
  make?: string = undefined
  model?: string = undefined
  year?: string = undefined
  vin?: string = undefined
  importerStockNumber?: string = undefined
  exporterCompany?: CompanyDto = undefined
  parkingSpace?: string = undefined
  damagePhoto1FileName?: string = undefined
  damagePhoto2FileName?: string = undefined
  damagePhoto3FileName?: string = undefined
}
